import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'radicadoFtn':			
							await this.updateDataForm({ state: 'servicios_activos', data: [] })
							if(this.dataForm[this.namePath].servicios_nuevos.iniciolabores!=='')
							{	
								if(this.dataForm[this.namePath].servicios_nuevos.name!=='Traslado')
								{
									let servicios_activos =_.filter(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos,[ 'name',this.dataForm[this.namePath].servicios_nuevos.name])
									let elements = {}
									if(servicios_activos.length>0)
									{
										elements = this.deepCopy(servicios_activos[0]);
										elements.iniciolabores=this.dataForm[this.namePath].servicios_nuevos.iniciolabores
										elements.archivo=this.dataForm[this.namePath].servicios_nuevos.archivo
									}
									else 
									{
										elements = this.deepCopy(this.dataForm[this.namePath].servicios_nuevos);
										elements.id=""
									}								
									
									const await20 = this.pushDataForm({ state: 'servicios_activos', data: elements})
									const await21 = this.updateDataPost({ 
										data: { 
											data: [],
											route: 'save_all', 
											tablaPost: ['servicios_activos','servicios_nuevos','subir_archivos'],
											tablaAuditar: true,
											tablaDelete:['servicios_nuevos']
										}
									})
									await Promise.all([await20,await21])
								}
								else 
								{
									let servicios_activos =_.filter(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos,{name: 'Eps', mes_periodo: this.dataForm[this.namePath].servicios_nuevos.mes_periodo, ano_periodo: this.dataForm[this.namePath].servicios_nuevos.ano_periodo})
									let elements = {}
									if(servicios_activos.length>0)
									{
										elements = this.deepCopy(servicios_activos[0]);
										elements.iniciolabores=this.dataForm[this.namePath].servicios_nuevos.iniciolabores
										elements.archivo=this.dataForm[this.namePath].servicios_nuevos.archivo
										elements.id_list=this.dataForm[this.namePath].servicios_nuevos.id_list
									}
									else 
									{
										elements = this.deepCopy(this.dataForm[this.namePath].servicios_nuevos);
										elements.id=""
									}								
									
									const await20 = this.pushDataForm({ state: 'servicios_activos', data: elements})
									const await21 = this.updateDataPost({ 
										data: { 
											data: [],
											route: 'save_all', 
											tablaPost: ['servicios_activos','servicios_nuevos','subir_archivos'],
											tablaAuditar: true,
											tablaDelete:['servicios_nuevos']
										}
									})
									await Promise.all([await20,await21])
								}
								
							} 
							else 
							{							
								await this.updateDataPost({ 
									data: { 
										data: [],
										route: 'pruebas_frontend', 
										tablaPost: ['servicios_nuevos'],
										tablaAuditar: true,
										tablaDelete:[]
									 }
								 })
							}											 
						break;
						case 'eliminarFtn':							
							this.changeGlobal({state: 'saveConfig/capa', boolean: true})
							this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaPost: ['servicios_nuevos','afiliacion_registro'],
									tablaAuditar: true,
									notaDelete: this.dataForm[this.namePath].servicios_nuevos.nota_delete,
									tablaDelete:['servicios_nuevos']
								 }
							 }) 

							let dataSearchBackend= await this.getData({ route: 'deletePendientes', data: {info_ingresos: this.dataForm[this.namePath].servicios_nuevos.id_info_ingresos,afiliacion_registro: this.dataForm[this.namePath].servicios_nuevos.id_afiliacion_registro }})

							dataSearchBackend.afiliacion_registro.servicios=dataSearchBackend.afiliacion_registro.servicios.filter(list => list.name!==this.dataForm[this.namePath].servicios_nuevos.name)							
							await this.updateDataForm({state: 'afiliacion_registro', data: dataSearchBackend.afiliacion_registro})						
							await this.updateDataForm({state: 'afiliacion_registro/nota_delete', data: this.dataForm[this.namePath].servicios_nuevos.nota_delete})		
							
							if(dataSearchBackend.info_ingresos.tipo===0)
							{	
								const await40 = this.updateDataPost({state: 'tablaPost', data: ['servicios_nuevos','info_ingresos','afiliacion_registro']})
								const await41 =  this.updateDataPost({state: 'tablaDelete', data: ['servicios_nuevos','info_ingresos']})
								const await42 =  this.updateDataForm({state: 'info_ingresos', data: dataSearchBackend.info_ingresos})			
								const await43 =  this.updateDataForm({state: 'info_ingresos/nota_delete', data: this.dataForm[this.namePath].servicios_nuevos.nota_delete})
								const await44 =  this.updateDataForm({state: 'info_ingresos/anulado', data: 1})
								await await40
								await await41
								await await42
								await await43
								await await44
							}
						break;
						case 'editarFichaFtn':
							var name= this.dataForm[this.namePath].datos_afiliado.nombre1+' '+this.dataForm[this.namePath].datos_afiliado.nombre2+' '+this.dataForm[this.namePath].datos_afiliado.apellido1+' '+this.dataForm[this.namePath].datos_afiliado.apellido2

							var re= /null/gi;
							
							let info_ingresos= { 
								id: _.filter(this.dataForm[this.namePath].servicios_activos,['name', 'Administración'])[0].id_info_ingresos,
								name: name.replace(re,' '),
								id_list_documento: this.dataForm[this.namePath].datos_afiliado.id_list_documento,
								documento: this.dataForm[this.namePath].datos_afiliado.documento,
								direccion: this.dataForm[this.namePath].datos_afiliado.direccion,
								telefonos: this.dataForm[this.namePath].datos_afiliado.telefonos,
								email: this.dataForm[this.namePath].datos_afiliado.email,
							}
														
							const await1 = this.updateDataForm({state: 'info_ingresos', data: info_ingresos})
							const await2 = this.updateDataForm({state: 'datos_afiliado/name', data: name.replace(re,' ')})
							const await3 = this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaPost: ['datos_afiliado','info_afiliacion','servicios_activos','info_ingresos'],
									tablaAuditar: true,
									notaDelete: null,
									tablaDelete: [],

								}
							}) 
							await Promise.all([await1,await2,await3])		
								if(this.dataForm[this.namePath].descuentos_referido.id!==null)
								{										
									this.updateDataPost({state: 'tablaPost', data: ['datos_afiliado','info_afiliacion','servicios_activos','info_ingresos','descuentos_referido']})
									if(this.dataForm[this.namePath].datos_afiliado.referido===null)
									{
										this.updateDataForm({state: 'descuentos_referido/nota_delete', data: 'se anulo el referido'})
										this.updateDataForm({state: 'descuentos_referido/deleted_at', data: this.fecha().fecha.hoy})
									}
									else
									{
										let descuentos_referidos= {
											id:this.dataForm[this.namePath].descuentos_referido.id, 
											referido:{ name: name.replace(re,' '), documento: this.dataForm[this.namePath].datos_afiliado.documento },
											id_datos_afiliado:this.dataForm[this.namePath].datos_afiliado.referido.id,
											id_info_afiliacion:this.dataForm[this.namePath].info_afiliacion.id,
											descuento: this.dataForm[this.namePath].descuentos_referido.descuento
										}
		
										this.updateDataForm({state: 'descuentos_referido', data: descuentos_referidos})
									}
								}
								else {
									if(this.dataForm[this.namePath].datos_afiliado.referido!==null)
									{
										this.updateDataPost({state: 'tablaPost', data: ['datos_afiliado','info_afiliacion','servicios_activos','info_ingresos','descuentos_referido']})
										let descuentos_referidos= {
											id:this.dataForm[this.namePath].descuentos_referido.id, 
											referido:{ name: name.replace(re,' '), documento: this.dataForm[this.namePath].datos_afiliado.documento },
											id_datos_afiliado:this.dataForm[this.namePath].datos_afiliado.referido.id,
											id_info_afiliacion:this.dataForm[this.namePath].info_afiliacion.id,
											descuento: this.dataForm[this.namePath].descuentos_referido.descuento
										}
		
										this.updateDataForm({state: 'descuentos_referido', data: descuentos_referidos})

									}
								}					 
						break;
						case 'agruparFtn': 								
							await this.updateDataForm({ state: 'servicios_activos', data: [] })
							await this.updateDataForm({ state: 'servicios_nuevos', data: [] })	
							const newData = []
							event.data.reduce((prev,current) => {
								if (!current.iniciolabores) {
									return prev 
								}
								newData = {
									servicios_activos: [
										...prev.servicios_activos,
									],
									servicios_nuevos: [
										...prev.servicios_nuevos
									],
									subir_archivo: [
										...prev.subir_archivo,
										{name: current.archivo}
									]
								}
							}, {
								servicios_activos: [],
								servicios_nuevos: [],
								subir_archivo: []
							})

							await this.updateDataPost({ 
								data: { 
									data: [...newData],
									route: 'save_all', 
									tablaPost: ['servicios_activos','servicios_nuevos','subir_archivos'],
									tablaAuditar: true,
									tablaDelete:['servicios_nuevos']
								}
							})
							break;
					}
				}
				await this.save(event.save)
				
				const await30 = this.getFiltrar()
				// frontend await this.searchGetIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
				const await31 =  this.resetDataIndex()
				const await32 =  this.resetGlobal({state: 'openModal'})
				const await33 =  this.resetDataForm()
				const await34 =  this.resetGlobal({state: 'saveConfig/capa'}) 
				
				await Promise.all([await30,await31,await32,await33,await34])
			}
			catch (e){
				console.log('saveMix afilaicion pendientes', e)

			}			
		}		
	},
}
